<template>
  <div>
    <!-- ヘッダ -->
    <comHeaderAnyone :propScreenTitle="screenTitle"></comHeaderAnyone>
    <!-- メイン -->
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="warning" elevation="2">
          {{ messageArea }}
        </v-alert>
        
        <!-- <v-row class="mt-8" style="height: 2vh;"></v-row> -->
        <!-- データ入力エリア -->
        <v-row class="pt-10">
          <v-col cols="0" sm="0" md="0" lg="2" xl="2"></v-col>
          <v-col cols="12" sm="12" md="12" lg="8" xl="8"  class="d-flex align-center justify-center px-1 pa-xl-16">
            <v-text-field
              label="メールアドレス"
              hint="パスワードの再設定用URLが記載された案内メールをお送りします。"
              outlined
              v-model="mailAddress"
              autofocus
            ></v-text-field>
          </v-col>
          <v-col cols="0" sm="0" md="0" lg="2" xl="2"></v-col>
        </v-row>
        
        <!-- <v-row class="mt-8" style="height: 1vh;"></v-row> -->

        <!-- ボタンエリア -->
        <v-row>
          <v-col cols="1" sm="1" md="1" lg="2" xl="2"></v-col>
          <v-col cols="5" sm="5" md="5" lg="4" xl="4" class="d-flex align-center justify-center pl-0">
            <v-btn x-large color="warning" dark min-width="160px" @click="send()">送信</v-btn>
          </v-col>
          <v-col cols="5" sm="5" md="5" lg="4" xl="4" class="d-flex align-center justify-center pr-0">
            <v-btn x-large color="warning" dark min-width="160px" :to="{name:'MBA100'}" >キャンセル</v-btn>
          </v-col>
          <v-col cols="1" sm="1" md="1" lg="2" xl="2"></v-col>
        </v-row>

      </v-container>
    </v-main>
    <!-- その他 -->
    <comMessage
      :msg="dlgMsg.msg"
      :is-open="dlgMsg.isOpen"
      :do-yes="dlgMsg.doYes"
    />

    <!-- フッター(なし) -->
  </div>
</template>

<script>
import Constants from '../common/constants';
import Utils from "../common/utils";
export default {
  name: "ResetPwdRequest",
  data() {
    return {
      screenTitle: "パスワード再設定依頼",
      screenId: "MBA200",
      messageArea: "",
      mailAddress: "",
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize: function() {
      this.messageArea = this.$i18n.t('webmsg.mba200.area');
    },
    /*
    * 送信ボタン押下
    */
    send: async function () {
      let responseData = null;
      let apiErrorInfo = null;
      try{
        let apiurl = Constants.URL_API_MBA200P01
        // 入力データ
        let data = JSON.stringify(this.createRequestData());
         // API呼出
        let response = await this.$axios.post(apiurl, data,
            {
              headers: {"content-type": "application/json"}, 
              responseType: "json",
            }); 
        responseData = response.data;
        console.log(response);
      } catch(error) {
        apiErrorInfo = error.response.data;
      } 
      // 完了メッセージ表示
      let hasError = this.showDialogMsgAfterAPICall(this.dlgMsg, apiErrorInfo, responseData);
      //次画面遷移
      if (!hasError) {
        this.$router.push(this.$router.resolve({ name: "MBA300", params: {authCd: responseData.data.authCd, reqDatetime: responseData.data.requestDatetime, validMinutes: responseData.data.validMinutes} }).href);
      }
      
    },

    //PWリセット用リクエストデータ生成
    createRequestData : function() {
      let reqData = {};
      reqData['mailAddress'] = this.mailAddress;
      return reqData;
    },

    /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(dialog, apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        dialog.msg = this.$i18n.t('msg.err.cm110', ['パスワードの再設定']);
        dialog.isOpen = true;
        return hasError;
      }
      // APIコール正常
      if (responseData.statusCd === 200) {
        // 処理正常
        hasError = false;
        return hasError;
      } else {
        // 処理異常
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          dialog.msg = Utils.createMsgViewStringForErrList(errorList);
          dialog.isOpen = true;
          return hasError;
        } else {
          dialog.msg = responseData.message ;
        }
      }
    },

  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
}
</style>
